define([
    "skylark-spa/spa"
], function(spa) {
    return spa;
});
